export default __webpack_public_path__ + "static/media/chat-help1.e6a08da2.png";